import { toast } from 'react-toastify';

import { uniqueId } from 'lodash';
import api from '../../api';
import { getUserLocalStorage, SignUpCredentials } from '../auth';
import { User } from './types';

export async function getUsersByCompanyIdRequest(
  companyId: string,
  search: string,
  page: string,
  size: string,
  type: string,
) {
  try {
    const response = await api().get(`/users/company/${companyId}`, {
      params: {
        search,
        page,
        size,
        type,
      },
    });

    return response;
  } catch (error) {
    console.error('Error getUsersByCompanyIdRequest', error);
    return null;
  }
}

export async function createUserRequest({
  email,
  name,
  profile,
  status,
  phone,
  companies_ids,
}: SignUpCredentials) {
  try {
    const response = await api().post('/users', {
      name,
      email,
      profile,
      status,
      phone,
      companies_ids,
    });

    if (response.status === 201) {
      toast.success('Usuário cadastrado com sucesso');
    }
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function updateUserRequest(userId: string, user: Partial<User>) {
  const userLogged = getUserLocalStorage() as User;

  const permission = userLogged.profile === 'UN1' || 'UN2';

  if (!permission) {
    toast.error('Erro ao editar usuário, você não tem permissão!');
    return null;
  }

  try {
    const response = await api().patch(`/users/${userId}`, {
      ...user,
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function deactivateUserRequest(
  userId: string,
  companyId: string,
  adminId: string,
) {
  try {
    const response = await api().patch(
      `/users/disable-user/${userId}`,
      {},
      {
        headers: {
          companyId,
          adminId,
        },
      },
    );

    toast.success('Usuário desativado com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function getUserByIdRequest(userId: string) {
  try {
    const response = await api().get(`/users/${userId}`);

    return response;
  } catch (error) {
    toast.error('Erro ao buscar usuário, tente novamente mais tarde');
    console.error(error);
    return null;
  }
}

export async function getUserByEmailRequest(emailUser: string) {
  try {
    const response = await api().get(`/users/email/${emailUser}`);

    return response;
  } catch (err) {
    toast.error('Erro ao buscar usuário, tente novamente mais tarde');
    console.error(err);
    return null;
  }
}
